
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Size } from "../../../domain/drawing";
import { DragKinds } from "../DragKinds";

@Component({
})
export default class DragHandleMixin extends Mixins() {
  dragSelf: DragKinds = DragKinds.Self;

  @Prop({ default: () => DragKinds.Self })
  kind: DragKinds;

  @Prop({ default: () => new Size(10, 10) })
  handleSize: Size;

  get handleWidth(): number {
    return this.handleSize.width;
  }

  get handleHeight(): number {
    return this.handleSize.height;
  }

  onDragHandleSelected(event: PointerEvent): void {
    event.preventDefault();
    this.dragHandleSelected(event, this.kind);
  }

  @Emit()
  dragHandleSelected(event: PointerEvent, kind: DragKinds): void {}
}
